import {useStorage} from '@vueuse/core';

/**
 * Shared storage between MyDummen and ShoppingCart to set the selected customer.
 */
const selectedCustomerStorage = useStorage<string>('selectedCustomer', null);

export const getSelectedCustomer = () => selectedCustomerStorage.value;

export const setSelectedCustomer = (selectedCustomer: string | null) => {
	selectedCustomerStorage.value = selectedCustomer;
};

export const resetSelectedCustomer = () => {
	selectedCustomerStorage.value = null;
};
